export default __webpack_public_path__ + "a3ca16cf8b8340423685c21f43aed477.png";